import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IosRegistrationFormRoutingModule } from './ios-registration-form-routing.module';
import { RegistrationFormComponent } from './registration-form/registration-form.component';


@NgModule({
  declarations: [
    RegistrationFormComponent
  ],
  imports: [
    CommonModule,
    IosRegistrationFormRoutingModule
  ]
})
export class IosRegistrationFormModule { }
